import { render, staticRenderFns } from "./MultiBannerSlider.vue?vue&type=template&id=5f3723fc&scoped=true&"
import script from "./MultiBannerSlider.vue?vue&type=script&lang=js&"
export * from "./MultiBannerSlider.vue?vue&type=script&lang=js&"
import style0 from "./MultiBannerSlider.vue?vue&type=style&index=0&id=5f3723fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3723fc",
  null
  
)

export default component.exports